import { isWithinInterval } from "date-fns";
import _, { get } from "lodash";
import { createSelector } from "reselect";

import { AppState } from "@app/statefx/xstore";

import { schema } from "../schema";
import { selectFxFilterRange } from "./uiMonthTree";

import type {
  TIvFiscal,
  TCommonInvoice,
  TSPVMessageUserState,
  TRepoSPVMessages,
} from "@app/types/insider";
type TAggregatedIVFiscal = TIvFiscal & TCommonInvoice;
//OVERDUE DAYS TO GET ALARMED ABOUT// not used yet
const trackCollectionOverdueDays = 0;

const collectionCond = (trackCollectionFilter, ivf: TIvFiscal) => {
  if (trackCollectionFilter === "ALL") return true;
  if (trackCollectionFilter === "COLLECTED") return ivf.REST_DE_INCASAT === 0;
  if (trackCollectionFilter === "UNCOLLECTED") return ivf.REST_DE_INCASAT > 0;
  if (trackCollectionFilter === "OVERDUE")
    return (
      ivf.REST_DE_INCASAT > 0 &&
      new Date(ivf.LA_DATA).getTime() +
        ivf.ZILE_SCADENTA * 24 * 60 * 60 * 1000 >
        new Date().getTime() + trackCollectionOverdueDays * 24 * 60 * 60 * 1000
    );

  return true;
};

export const selectInvoiceDataOverall = createSelector(
  schema.uiInvoiceOverall.select,
  schema.invoiceFiscal.selectTableAsList,
  selectFxFilterRange,
  (settings, iFiscal, range) => {
    const { fromDate, toDate } = range;
    const res = iFiscal.filter(
      (i: TAggregatedIVFiscal) =>
        i.OurCIF === settings.selectedCIF &&
        isWithinInterval(new Date(i.DateIssued), {
          start: fromDate,
          end: toDate,
        })
      // filtered in front-end
      // && collectionCond(settings.trackCollectionFilter, i)
    );
    return res;
  }
);

//  The special encoding of the date sent by the SPV system //
// an integer formed by the concatenation of the year, month and day
// year as integer,
// paddded with 0 if less than 10 the month
// paddded with 0 if less than 10 the day

const dateAsInt = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  return parseInt(
    `${year}${month < 10 ? "0" : ""}${month}${day < 10 ? "0" : ""}${day}2359`
  );
};

const replaceRo = (cif) => {
  return cif.replace("RO", "").trim();
};

const markedByFXMID = createSelector(
  schema.SPVMessageUserState.selectTableAsList,
  (marks) => {
    return marks.reduce(
      (
        acc: { [key: string]: TSPVMessageUserState },
        m: TSPVMessageUserState
      ) => {
        acc[m.FXM_ID] = m;
        return acc;
      },
      {}
    );
  }
);
export const selectSpvDataOverall = createSelector(
  schema.uiInvoiceOverall.select,
  schema.SPVMessages.selectTableAsList,
  markedByFXMID,
  selectFxFilterRange,
  (settings, messages, userMarks, range) => {
    const from = dateAsInt(range.fromDate);
    const to = dateAsInt(range.toDate);
    return messages
      .filter(
        (m) =>
          m.QMY_CIF === replaceRo(settings.selectedCIF) &&
          +m.QDATA_CREARE >= from &&
          +m.QDATA_CREARE <= to
      )
      .map((m: TRepoSPVMessages) => ({
        ...m,
        READ_STATE: userMarks[m.FXM_ID]?.READ_STATE || "NOT_READ",
        MARKED_STATE: userMarks[m.FXM_ID]?.MARKED_STATE || "NO_MARK",
        FMUS_ID: userMarks[m.FXM_ID]?.FMUS_ID || -1,
      }));
  }
);

export const selectCollectionInEdit = createSelector(
  schema.uiCollectionCurrent.select,
  schema.invoiceCollection.selectTable,
  (settings, iCollection) => {
    return iCollection?.[settings.iidInEdit] || {};
  }
);

export const selectToolbarForInvoiceOverall = createSelector(
  schema.uiInvoiceOverall.select,
  (settings) => {
    return {
      selectedCIF: settings.selectedCIF,
      currentCurrency: settings.currentCurrency,
      trackCollectionFilter: settings.trackCollectionFilter,
      colorized: settings.colorized,
    };
  }
);
type HashPairMap = Record<string, [string, string]>;
export const selFiscalInvoiceHashPairs = createSelector(
  schema.invoiceFiscal.selectTableAsList,
  (invoices): [string, string][] => {
    const hashPairMap: HashPairMap = {};
    for (const inv of invoices) {
      const key = `${inv._hkey}-${inv._hvalue}`;
      if (!hashPairMap[key]) {
        hashPairMap[key] = [inv._hkey, inv._hvalue];
      }
    }
    return Object.values(hashPairMap);
  }
);

function createParameterSelector(selector: any) {
  return (_: AppState, params: any) => selector(params);
}
const getTableName = createParameterSelector((params) => params.tableName);
const getHashKey = createParameterSelector((params) => params.hashKey);

export const selectKeysOfTable = createSelector(
  getTableName,
  getHashKey,
  (tableName, hashKey) => {
    const tableSchema = schema[tableName].selectTable;
    return Object.keys(tableSchema).filter(
      (key) => tableSchema[key]["_hkey"] === hashKey
    );
  }
);
// this  text is inserted from neovim in tmux
// now what?
